import { establishOrRefreshSession } from '../../../common/sessionGate'
import { signInStorageHandler } from './storageHandler'
import { verifyDomain, loginAuth } from './authApiCalls'
import { populatePermissions } from './LocalStoragePermissionsHandler'
import ApiService from '../../../common/ApiCalls'
import { globalStore } from '../../../common/redux.Interface.Store'
import { setUsername, setImageUrl } from '../../../v2/store/users';
import jwt_decode from 'jwt-decode'

/**
 * Handles successful response from google login
 * and tries to verifies domain.
 * Successful verification logs user in
 * @param response - google login response
 * @throws error - on interval server error
 * @returns {Promise<boolean>} - domain verification
 */
const responseGoogle = async response => {
  const token = response.credential
  const decoded = jwt_decode(token)
  const userEmail = (decoded && decoded.email) || ''
  let domainVerificationResponse = await verifyDomain(userEmail)
  if (!domainVerificationResponse) {
    return false
  }
  if (domainVerificationResponse?.data?.data?.success) {
    await setLoginData(decoded.name, decoded.picture, token)
    await ApiService().postAvatarFromSSO(userEmail, decoded.picture)
    const target = window.localStorage.getItem('activeTab')

    if (target && !target.toLowerCase().includes('login')) {
      window.location.replace(target)
    } else {
      window.location.replace('/')
    }
  } else {
    console.log('Google auth failed!', domainVerificationResponse)
    return false
  }
  return true
}

async function setLoginData (name, imageUrl, token) {
  window.localStorage.setItem('username', name);
  window.localStorage.setItem('image_url', imageUrl);
  globalStore.dispatch(setUsername(name));
  globalStore.dispatch(setImageUrl(imageUrl));
  establishOrRefreshSession();
  await makeLogin(token);
}

async function makeLogin (token) {
  let authLoginResponse = await loginAuth(token, 'google')
  if (authLoginResponse === null) {
    console.log('Login Auth call failed!')
    return
  }
  populatePermissions(authLoginResponse)
  signInStorageHandler(authLoginResponse, 'google')
}

const failedGoogleAuthMessage = async response => {
  console.log('Google auth button trigger onFail')
  console.log(response)
}

export { responseGoogle, failedGoogleAuthMessage }
